var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01292 12.7285C6.87492 12.7285 6.76292 12.8405 6.76392 12.9785C6.76392 13.1165 6.87592 13.2285 7.01392 13.2285C7.15192 13.2285 7.26392 13.1165 7.26392 12.9785C7.26392 12.8405 7.15192 12.7285 7.01292 12.7285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0129 12.7285C11.8749 12.7285 11.7629 12.8405 11.7639 12.9785C11.7639 13.1165 11.8759 13.2285 12.0139 13.2285C12.1519 13.2285 12.2639 13.1165 12.2639 12.9785C12.2639 12.8405 12.1519 12.7285 12.0129 12.7285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0129 12.7285C16.8749 12.7285 16.7629 12.8405 16.7639 12.9785C16.7639 13.1165 16.8759 13.2285 17.0139 13.2285C17.1519 13.2285 17.2639 13.1165 17.2639 12.9785C17.2639 12.8405 17.1519 12.7285 17.0129 12.7285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01292 16.7285C6.87492 16.7285 6.76292 16.8405 6.76392 16.9785C6.76392 17.1165 6.87592 17.2285 7.01392 17.2285C7.15192 17.2285 7.26392 17.1165 7.26392 16.9785C7.26392 16.8405 7.15192 16.7285 7.01292 16.7285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0129 16.7285C11.8749 16.7285 11.7629 16.8405 11.7639 16.9785C11.7639 17.1165 11.8759 17.2285 12.0139 17.2285C12.1519 17.2285 12.2639 17.1165 12.2639 16.9785C12.2639 16.8405 12.1519 16.7285 12.0129 16.7285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarioIcon);
export default __webpack_public_path__ + "static/media/calendarioIcon.f9d823fed6f780217c88016cb257f613.svg";
export { ForwardRef as ReactComponent };